module.exports = __webpack_public_path__ + "img/Structures-Inspect-Small.14d05ce1.png";